/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const walletHoldDataSchema = z.object({
	id: z.string(),
	amount: z.number(),
	description: z.string().nullable(),
	heldAt: z.iso.datetime(),
})

export type WalletHoldDataSchema = z.infer<typeof walletHoldDataSchema>
